import { getRouter } from '@/routes/router';
import { hasAnyAuthToken } from '@repo/api';
import { shouldRetryQuery, useUserDetailsQuery } from '@repo/lib';
import {
  matchQuery,
  MutationCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { Spinner } from '@ui/components';
// import { SnowEffect } from '@ui/components';
// import { SnowEffectProvider, useSnowEffect } from '@ui/providers';
import { StrictMode, useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import './global.css';
import './globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetryQuery,
      staleTime: 60 * 1000 * 10,
    },
  },
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      void queryClient.invalidateQueries({
        predicate: (query) =>
          !!mutation?.meta?.invalidateKeys?.some((queryKey) =>
            matchQuery({ queryKey }, query),
          ),
      });
    },
  }),
});

function App() {
  return (
    <StrictMode>
      {/* Christmas features disabled. Uncomment to re-enable snow effect. */}
      {/* <SnowEffectProvider> */}
      <QueryClientProvider client={queryClient}>
        {/* <SnowEffectLayer /> */}
        <RouterWrapper />
      </QueryClientProvider>
      {/* </SnowEffectProvider> */}
    </StrictMode>
  );
}

export default App;

const RouterWrapper = () => {
  const isImpersonateRoute = window.location.pathname === '/impersonate';
  const hasAuthToken = hasAnyAuthToken();
  const { isLoading } = useUserDetailsQuery(hasAuthToken && !isImpersonateRoute);

  const router = useMemo(() => getRouter(), []);

  if (isLoading) {
    return (
      <div className="absolute inset-0">
        <Spinner className="size-14 text-primary" />
      </div>
    );
  }

  return <RouterProvider router={router} />;
};

// const SnowEffectLayer = () => {
//   const { enabled } = useSnowEffect();
//
//   if (!enabled) {
//     return null;
//   }
//
//   return <SnowEffect />;
// };
